import React, { Component } from "react";
import SkyLogo from "_assets/img/logo.png";
import "./Loading.scss";

export default class Loading extends Component {
  render() {
    return (
      <div id="paypath-loading">
        <img src={SkyLogo} alt="" />
      </div>
    );
  }
}
